<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";
import DataTable from "@/components/DataTable.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Creditors",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
  },
  data() {
    return {
      title: "Credit Purchases",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Creditors",
          active: true,
        },
      ],

      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 50,
      IsCreditorsDataServerPaginated: true,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",

      clear: {
        id: "",
        date: null,
        paid: "",
        mode: "",
        totals: "",
        filters: {},
      },
      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        supplier: "",
        period: 0,
        user: "",
        page: 1,
        per_page: 50,
      },
      amountError: "",
      modeError: "",
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("purchase", [
      "SaveStatus",
      "FilterStatus",
      "CreditorsData",
      "CreditorsDataPagination",
      "CreditorsDataSummary",
      "PurchaseId",
      "CreditorsDataPaginated",
    ]),
    ...mapGetters("setting", ["PaymentOptions", "ReceiptSettings"]),
    ...mapGetters("auth", ["MyUserPerm"]),
    ...mapGetters("stock", ["Suppliers"]),
    ...mapGetters("users", ["Users"]),

    rows() {
      return this.IsCreditorsDataServerPaginated
        ? this.CreditorsDataPagination?.total
        : this.CreditorsData
        ? this.CreditorsData.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsCreditorsDataServerPaginated) {
          return (
            (this.CreditorsDataPagination &&
              this.CreditorsDataPagination.per_page) ||
            this.data.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsCreditorsDataServerPaginated) {
          this.data.per_page = value;
          this.data.page = 1;
          this.FetchCreditors(this.data);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.CreditorsDataPaginated && this.CreditorsDataPagination
          ? this.CreditorsDataPagination.current_page
          : 1;
      },
      set(value) {
        if (this.CreditorsDataPaginated) {
          this.data.page = value;
          this.handlePageChange(value);
        }
      },
    },

    totals() {
      return (
        this.CreditorsDataSummary || {
          totalAmount: 0,
          totalPaid: 0,
          totalDiscount: 0,
          totalBalance: 0,
        }
      );
    },

    creditorColumns() {
      return [
        {
          key: "sn",
          label: "S/N",
          formatter: (_, __, idx) => this.CreditorsDataPagination.from + idx,
        },
        {
          key: "supplier",
          label: "SUPPLIER",
        },
        {
          key: "products",
          label: "PRODUCTS",
        },
        {
          key: "totalAmt",
          label: "TOTAL",
          formatter: (v) => this.thousandSeperator(v ?? 0),
        },
        {
          key: "amtPaid",
          label: "PAID",
          formatter: (v) => this.thousandSeperator(v ?? 0),
        },
        {
          key: "discount",
          label: "DISCOUNT",
          formatter: (v) => this.thousandSeperator(v ?? 0),
        },
        {
          key: "balance",
          label: "BALANCE",
          formatter: (v) => this.thousandSeperator(v ?? 0),
        },
        { key: "date", label: "DATE" },
        { key: "user", label: "RECORDED BY" },
        { key: "actions", label: "ACTIONS", tdClass: "text-nowrap" },
      ];
    },
  },

  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },

    PurchaseId(newValue) {
      if (newValue && this.ReceiptSettings.print_receipt_after_purchase == 1) {
        window.open(
          `https://${
            window.location.host
          }/receipts/creditorsreceipt.php?id=${btoa(newValue)}`
        );
      }
    },
  },

  methods: {
    ...mapActions({
      FetchCreditors: "purchase/fetchCreditorsData",
      ClearBalance: "purchase/ClearCredit",
      ClearBalancePrint: "purchase/ClearCreditPrint",
      FetchModes: "setting/fetchPaymentOptions",
      FetchReceiptSettings: "setting/fetchReceiptSettings",
      FetchSuppliers: "stock/fetchSuppliers",
      FetchUsers: "users/fetchUsers",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered() {
      if (!this.IsCreditorsDataServerPaginated) {
        this.clientCurrentPage = 1;
      }
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    setDefaultMode() {
      let defaultop = this.PaymentOptions
        ? this.PaymentOptions
        : [].filter((mode) => {
            return mode.default == 1;
          });
      this.clear.mode = defaultop[0] ? defaultop[0].id : 0;
    },
    resetModal() {
      this.clear.id = "";
      this.clear.paid = "";
      this.setDefaultMode();
      this.clear.total = "";
    },
    resetError() {
      this.amountError = "";
      this.modeError = "";
    },
    addCommas() {
      this.clear.paid = this.thousandSeperator(this.clear.paid);
    },
    ShowClear(data) {
      this.clear.id = data.id;
      this.clear.paid = (
        data.totAmt -
        data.amtPaid -
        data.discount
      ).toLocaleString();
      this.clear.total = data.totAmt;
    },
    checkAmt() {
      if (this.clear.paid.replace(/,/g, "") > this.clear.total) {
        this.amountError = "Amount Paid is greater than balance";
        return;
      } else {
        this.amountError = "";
      }
    },
    clearAmt(modalId) {
      this.modal_id = modalId;
      if (this.clear.paid == "") {
        this.amountError = "Amount Paid is required";
        return;
      } else {
        this.amountError = "";
      }
      if (this.clear.paid.replace(/,/g, "") > this.clear.total) {
        this.amountError = "Amount Paid is greater than balance";
        return;
      } else {
        this.amountError = "";
      }
      if (this.clear.mode == "") {
        this.modeError = "Payment Method is required";
        return;
      } else {
        this.modeError = "";
      }
      this.clear.filters = this.data;
      this.ClearBalance(this.clear);
    },

    clearAmtPrint(modalId) {
      this.modal_id = modalId;
      if (this.clear.paid == "") {
        this.amountError = "Amount Paid is required";
        return;
      } else {
        this.amountError = "";
      }
      if (this.clear.paid.replace(/,/g, "") > this.clear.total) {
        this.amountError = "Amount Paid is greater than balance";
        return;
      } else {
        this.amountError = "";
      }
      if (this.clear.mode == "") {
        this.modeError = "Payment Method is required";
        return;
      } else {
        this.modeError = "";
      }
      this.clear.filters = this.data;
      this.ClearBalancePrint(this.clear);
      this.closeModal(modalId);
    },
    closeModal(modalId) {
      this.resetError();
      this.resetModal();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

     filterReport() {
      let payload = { ...this.data };
      payload.page = 1;
      payload.per_page = this.IsCreditorsDataServerPaginated
        ? this.perPage
        : this.serverPerPage;

      this.FetchCreditors(payload);
    },

    handlePageChange(newPage) {
      if (this.IsCreditorsDataServerPaginated) {
        this.data.page = newPage;
        this.FetchCreditors(this.data);
      }
    },

    Excel_export() {
      axios
        .post("export_creditors", this.data, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "creditors_report.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.spinner = false;
        })
        .catch(() => {});
    },
  },
  created() {
    this.FetchModes();
    this.FetchSuppliers();
    this.FetchCreditors(this.data);
    setTimeout(() => {
      this.setDefaultMode();
    }, 3000);
    this.FetchReceiptSettings();
    this.FetchUsers();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row text-center">
              <h4 class="card-title">Items Bought On Credits</h4>
            </div>

            <div class="row">
              <div class="col-md-9 mt-4">
                <router-link to="/purchases/imported_creditors">
                  <b-button variant="info">Imported Creditors</b-button>
                </router-link>
              </div>
              <div class="col-md-3 form-group">
                <label>USERS</label>
                <model-list-select
                  :list="
                    Users ? [{ id: '', names: 'All Users' }, ...Users] : []
                  "
                  v-model="data.user"
                  option-value="id"
                  option-text="names"
                  placeholder="Select User"
                  @input="filterReport()"
                >
                </model-list-select>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <div class="form-group">
                  <label>From</label>
                  <input
                    type="date"
                    v-model="data.datefrom"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-2">
                <div class="form-group">
                  <label>To</label>
                  <input
                    type="date"
                    v-model="data.dateto"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label>Supplier</label>

                <model-list-select
                  :list="
                    Suppliers
                      ? [{ id: '', name: 'All Suppliers' }, ...Suppliers]
                      : []
                  "
                  v-model="data.supplier"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Supplier"
                  @input="filterReport()"
                >
                </model-list-select>
              </div>
              <div class="col-md-2 form-group">
                <label>Period</label>
                <select class="form-control" v-model="data.period">
                  <option value="0" selected>Selected</option>
                  <option value="1" selected>All time</option>
                </select>
              </div>
              <div class="col-md-2 mt-4">
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="filterReport()"
                >
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="FilterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                  v-if="!IsCreditorsDataServerPaginated"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
                :columns="creditorColumns"
                :rows="CreditorsData"
                :total-rows="rows"
                :pagination="CreditorsDataPagination"
                :server-pagination="IsCreditorsDataServerPaginated"
                :loading="FilterStatus"
              >
                <template #cell(sn)="{ index }">
                  {{ CreditorsDataPagination.from + index }}
                </template>

                <template #cell(supplier)="{ value }">
                  {{ value }}
                </template>

                <template #cell(products)="{row}">
                    <table class="table">
                      <tbody>
                      <tr v-for="(det,d) in row.items" :key="d" width="100%">
                        <td>{{ det.product }}</td>
                        <td>{{ det.qty }}{{ det.usymbol }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </template>

                <template #cell(totalAmt)="{ value }">
                  {{ thousandSeperator(value ?? 0) }}
                </template>

                <template #cell(amtPaid)="{ value }">
                  {{ thousandSeperator(value ?? 0) }}
                </template>

                <template #cell(discount)="{ value }">
                  {{ thousandSeperator(value ?? 0) }}
                </template>

                <template #cell(balance)="{ value }">
                  {{ thousandSeperator(value ?? 0) }}
                </template>

                <template #cell(date)="{ value }">
                  {{ value }}
                </template>

                <template #cell(user)="{ value }">
                  {{ value }}
                </template>

                <template #cell(actions)="{ row }">
                  <div v-if="MyUserPerm.clear_creditors == 1">
                    <button
                      @click="ShowClear(row)"
                      class="btn btn-primary btn-sm"
                      v-b-modal.clear-modal
                    >
                      <i class="fa fa-check"></i> Clear
                    </button>
                  </div>
                </template>
              </DataTable>

              <div class="row">
                <div class="col-md-3">
                  <h5>
                    Total Amount:
                    <span class="text-danger">{{
                      thousandSeperator(totals.totalAmount)
                    }}</span>
                  </h5>
                </div>
                <div class="col-md-3">
                  <h5>
                    Total Paid:
                    <span class="text-danger">{{
                      thousandSeperator(totals.totalPaid)
                    }}</span>
                  </h5>
                </div>
                <div class="col-md-3">
                  <h5>
                    Total Discount:
                    <span class="text-danger">{{
                      thousandSeperator(totals.totalDiscount)
                    }}</span>
                  </h5>
                </div>
                <div class="col-md-3">
                  <h5>
                    Total Balance:
                    <span class="text-danger">{{
                      thousandSeperator(totals.totalBalance)
                    }}</span>
                  </h5>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      aria-controls="tickets-table"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal mark as expired starts -->
    <b-modal id="clear-modal" hide-footer @hidden="resetModal()">
      <template #modal-title>
        <h4 class="text-warning">
          Clear Credit of {{ thousandSeperator(clear.paid) }}
        </h4></template
      >
      <label>Amount Paid</label>
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          v-model="clear.paid"
          placeholder="Quantity removed"
          @input="resetError(), addCommas(), checkAmt()"
        />
      </div>
      <div class="text-danger" v-if="amountError">
        <em>{{ amountError }}</em>
      </div>
      <div class="form-group">
        <label>Payment Method <span class="text-danger">*</span></label>
        <model-list-select
          :list="PaymentOptions ? PaymentOptions : []"
          v-model="clear.mode"
          option-value="id"
          option-text="mode"
          placeholder="Select Method"
          @input="resetError()"
        >
        </model-list-select>
      </div>
      <div class="text-danger" v-if="modeError">
        <em>{{ modeError }}</em>
      </div>
      <div
        class="form-group"
        v-if="MyUserPerm && MyUserPerm.backdate_payments == 1"
      >
        <label>Payment Date</label>
        <div class="input-group">
          <input
            type="date"
            class="form-control"
            v-model="clear.date"
            v-limit-future-date
          />
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-4">
          <button
            v-if="SaveStatus"
            type="button"
            class="btn btn-warning"
            disabled
          >
            <i class="fa fa-minus"></i> Confirm & Exit
            <b-spinner variant="light" small label="Submiting"></b-spinner>
          </button>
          <button
            v-else
            type="button"
            class="btn btn-warning"
            @click="clearAmt('clear-modal')"
          >
            <i class="fa fa-minus"></i> Confirm & Exit
          </button>
        </div>
        <div class="col-md-4"></div>
        <div class="col-md-4">
          <button
            v-if="SaveStatus"
            type="button"
            class="btn btn-warning"
            disabled
          >
            <i class="fa fa-minus"></i> Confirm & Print
            <b-spinner variant="light" small label="Submiting"></b-spinner>
          </button>
          <button
            v-else
            type="button"
            class="btn btn-warning"
            @click="clearAmtPrint('clear-modal')"
          >
            <i class="fa fa-minus"></i> Confirm & Print
          </button>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}

.creditor-table-bordered td {
  border-bottom: 1px solid #000 !important;
}
</style>
